import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ResetSection() {
  const tableData = [{
    sit: 'No sé por dónde empezar',
    sin: 'Sin orden claro',
    con: 'Una acción por día durante 30 días'
  }, {
    sit: 'Leo pero no implemento',
    sin: 'Buenas intenciones',
    con: 'Indicador de éxito diario'
  }, {
    sit: 'Me pierdo entre los tomos',
    sin: 'Abro todo y no termino nada',
    con: 'Referencia exacta de tomo y página'
  }, {
    sit: 'Tuve un día malo',
    sin: 'Ansiedad y abandono',
    con: 'Protocolo de retomo sin culpa'
  }, {
    sit: 'Quiero llegar al médico con datos',
    sin: 'Síntomas vagos',
    con: 'Informe médico listo al Día 30'
  }];
  const includes = ['Hoja de Ruta Diaria', 'Indicadores de Éxito', 'Referencias Cruzadas a Tomos', 'Protocolo de Retomo Sin Culpa', 'Informe Médico al Día 30', 'Sistema de Implementación Guiado', 'Plan Maestro 30 Días'];
  return <section className="py-24 bg-brand-black border-t border-brand-gold/20" data-id="element-246">
      <div className="container mx-auto px-4" data-id="element-247">
        <div className="max-w-5xl mx-auto" data-id="element-248">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-249">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-gold mb-4 font-[Poppins,_sans-serif]" data-id="element-250">
              🌱 ¿QUÉ AGREGA EL PLAN DE ACCIÓN 30 DÍAS?
            </h2>
          </motion.div>

          {/* Desktop table */}
          <div className="hidden md:block overflow-x-auto mb-16 rounded-xl border border-gray-800" data-id="element-251">
            <table className="w-full text-left border-collapse" data-id="element-252">
              <thead data-id="element-253">
                <tr className="bg-brand-dark" data-id="element-254">
                  <th className="p-4 border-b border-gray-800 font-bold text-white w-1/3" data-id="element-255">
                    Problema real
                  </th>
                  <th className="p-4 border-b border-gray-800 font-bold text-red-400 w-1/3" data-id="element-256">
                    <div className="flex items-center gap-2" data-id="element-257">
                      <X className="w-4 h-4" data-id="element-258" /> Sin Plan
                    </div>
                  </th>
                  <th className="p-4 border-b border-gray-800 font-bold text-brand-light w-1/3" data-id="element-259">
                    <div className="flex items-center gap-2" data-id="element-260">
                      <Check className="w-4 h-4" data-id="element-261" /> Con Plan
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800" data-id="element-262">
                {tableData.map((row, i) => <tr key={i} className="hover:bg-brand-dark/50 transition-colors" data-id="element-263">
                    <td className="p-4 text-gray-300" data-id="element-264">{row.sit}</td>
                    <td className="p-4 text-gray-500" data-id="element-265">{row.sin}</td>
                    <td className="p-4 text-brand-light font-medium" data-id="element-266">
                      {row.con}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile stacked cards */}
          <div className="md:hidden mb-16 rounded-2xl border border-gray-800 overflow-hidden" data-id="element-267">
            {/* Header */}
            <div className="bg-brand-dark p-5 flex flex-col items-center gap-3" data-id="element-268">
              <div className="flex items-center gap-2 text-red-400 font-bold text-base" data-id="element-269">
                ❌ Sin Plan
              </div>
              <div className="flex items-center gap-2 text-brand-light font-bold text-base" data-id="element-270">
                ✅ Con Plan
              </div>
            </div>

            {/* Rows */}
            {tableData.map((row, i) => <div key={i} className="border-t border-gray-800" data-id="element-271">
                {/* Problema */}
                <div className="px-5 py-4 bg-brand-black" data-id="element-272">
                  <p className="text-xs font-bold text-gray-400 mb-1" data-id="element-273">
                    Problema real:
                  </p>
                  <p className="text-sm text-gray-200" data-id="element-274">{row.sit}</p>
                </div>
                {/* Sin Plan */}
                <div className="px-5 py-4 bg-brand-dark/80" data-id="element-275">
                  <p className="text-xs font-bold text-red-400 mb-1 flex items-center gap-1.5" data-id="element-276">
                    ❌ Sin Plan:
                  </p>
                  <p className="text-sm text-gray-400" data-id="element-277">{row.sin}</p>
                </div>
                {/* Con Plan */}
                <div className="px-5 py-4 bg-brand-green/5" data-id="element-278">
                  <p className="text-xs font-bold text-brand-light mb-1 flex items-center gap-1.5" data-id="element-279">
                    ✅ Con Plan:
                  </p>
                  <p className="text-sm text-gray-200" data-id="element-280">{row.con}</p>
                </div>
              </div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-gold/5 border border-brand-gold/20 rounded-2xl p-8 md:p-10" data-id="element-281">
            <h3 className="text-xl font-bold text-brand-gold mb-6 text-center" data-id="element-282">
              ✅ EL PLAN DE ACCIÓN 30 DÍAS INCLUYE:
            </h3>
            <div className="flex flex-wrap justify-center gap-3" data-id="element-283">
              {includes.map((item, index) => <span key={index} className="bg-brand-dark border border-brand-gold/30 text-gray-200 px-4 py-2 rounded-full text-sm" data-id="element-284">
                  {item}
                </span>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}